import styled from 'styled-components';

const ReconnectIconSvg = styled.svg`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;

export default function ReconnectIcon() {
  return (
    <ReconnectIconSvg viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path
        d="M2.5 7.5a5.5 5.5 0 0 1 9.4-3.9M13.5 8.5a5.5 5.5 0 0 1-9.4 3.9"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9 2v2.6h-2.6M4.1 14v-2.6h2.6"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </ReconnectIconSvg>
  );
}
